let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("89jKa")).then(() => parcelRequire('9HSvn'));